import React from "react";

const Page404 = () => {
  return <>Not Found | 404</>;
};
export default Page404;
